/* global System */

export default {
  WertErmittlerModalButton: () =>
    System.import(/* webpackChunkName: "WertErmittlerModalButton" */ './index'),
}
